import React from 'react';
import BEM from '../../bem';

const classes = BEM.with('EmptyRoomCard');

export default function EmptyRoomCard({ children }: { children: JSX.Element }) {
  return <div className={classes()}>{children}</div>;
}
